module.exports = __webpack_public_path__ + "img/sciencepage6.fdc6d99b.png";